import { HStack, Icon, Spinner, Text } from '@chakra-ui/react'
import type { FC } from 'react'
import { PiWarningOctagon } from 'react-icons/pi'
import { Link } from 'react-router-dom'

import { Tag } from '@app/components/ui/tag'
import useGetObjectsByProperties from '@app/hooks/useGetObjectsByProperties'
import ICON_MAP from '@app/utils/iconMap'
import type { BusinessContextsQuery } from '@graphql/queries'
import { TaskTypesEnum } from '@graphql/types'

interface Props {
  folder: BusinessContextsQuery['businessContexts'][0]
}

const Folder: FC<Props> = ({ folder }) => {
  const tasks = useGetObjectsByProperties('task', {
    taskType: TaskTypesEnum.ContextCreate,
    domainObjectType: 'BusinessContext',
    domainObjectId: folder.id
  })

  let iconComponent = (
    <Icon size="sm">
      <ICON_MAP.Folder />
    </Icon>
  )

  if (tasks.length) {
    const task = tasks.pop()

    if (task?.status === 'in_progress') {
      iconComponent = <Spinner size="xs" color="blue.500" />
    } else if (task?.status === 'failed') {
      iconComponent = (
        <Icon size="sm" color="red.500">
          <PiWarningOctagon />
        </Icon>
      )
    }
  }

  return (
    <Link key={folder.id} to={`/maps/${folder.slug}`}>
      <Tag size="xl" colorPalette="gray">
        <HStack _hover={{ color: 'blue.500' }} transition="color 0.2s">
          {iconComponent}
          <Text>{folder.name}</Text>
        </HStack>
      </Tag>
    </Link>
  )
}

export default Folder
